import { Skeleton } from '@/components/ui/skeleton';
import { AppTopNavContainer } from '@/components/app-top-nav';
import {
  NewHomeLayoutContent,
  NewHomeLayoutTopNav,
} from '@/views/home/new-home-layout';
import { useViewMode } from '../states';

const EmbeddedScreenSkeleton = () => {
  return (
    <>
      <AppTopNavContainer>
        <Skeleton className="w-64 h-11" />
        <span className="flex-1" />
        <Skeleton className="w-32 h-11" />
        <Skeleton className="w-32 h-11" />
      </AppTopNavContainer>
      <NewHomeLayoutContent>
        <div className="font-sans h-full flex">
          {/* LEFT CONFIG TAB */}
          <div className="w-[426px] h-full">
            <div className="flex flex-col gap-3 p-6">
              <div className="flex items-center gap-2 ">
                <Skeleton className="w-20 h-10" />
                <Skeleton className="w-20 h-10" />
                <Skeleton className="w-20 h-10" />
              </div>

              {/* DATASET BLOCK */}
              <div className="border border-grayscale-100 rounded-lg min-h-[462px] flex flex-col">
                {/* HEADER */}
                <div className="h-12 p-4 border-b border-grayscale-100 flex justify-between items-center">
                  <Skeleton className="w-40 h-full" />
                  <i className="ti ti-chevron-down text-grayscale-600" />
                </div>
                {/* BODY */}
                <div className="flex-1 min-h-0 flex flex-col p-4">
                  <Skeleton className="flex-1 min-h-0 w-full" />
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT CHART PREVIEW */}
          <div className="flex flex-col items-center flex-1 border-l border-grayscale-100 gap-4 p-6 pt-20 bg-grayscale-50">
            <div className="border border-grayscale-100 rounded-lg w-full min-h-[609px] p-4 bg-white flex flex-col">
              <Skeleton className="flex-1 min-h-0 w-full" />
            </div>
          </div>
        </div>
      </NewHomeLayoutContent>
    </>
  );
};

const ChartToolsBar = () => {
  return (
    <div className="flex gap-4 justify-between items-center w-full pointer-events-none">
      {/* SEARCH INPUT */}
      <Skeleton className="h-11 w-[260px]" />

      <div className="flex gap-3 items-center">
        {/* VIEW MODE TOGGLE */}
        <Skeleton className="w-[76px] h-11" />

        {/* CHART FILTER */}
        <Skeleton className="w-[90px] h-11" />

        <Skeleton className="h-11 w-[170px]" />
      </div>
    </div>
  );
};

const ChartCardPlaceholder = () => (
  <div style={{ height: 305 }} className="overflow-hidden  rounded">
    <Skeleton className="size-full" />
  </div>
);

export const ChartCardViewTableSkeleton = () => {
  return (
    <div className="flex-1 min-h-0 overflow-y-auto flex flex-col justify-between">
      <div className="space-y-4">
        <Skeleton className="w-full h-10" />
        {Array.from({ length: 4 }).map((_, index) => (
          <div className="flex">
            <div className="flex-1 flex gap-3">
              <Skeleton className="rounded-full h-10 w-10" />
              <Skeleton className="w-32 h-10" />
            </div>
            <div className="flex-1">
              <Skeleton className="w-32 h-10" />
            </div>
            <div className="flex-1">
              <Skeleton className="w-32 h-10" />
            </div>
            <div className="flex-1">
              <Skeleton className="float-end w-10 mr-8 h-10" />
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-between">
        <div>
          <Skeleton className="w-32 h-8" />
        </div>
        <div>
          <Skeleton className="w-64 h-8" />
        </div>
      </div>
    </div>
  );
};

export const ChartCardViewGridSkeleton = () => {
  return (
    <div className="flex-1 min-h-0 overflow-y-auto flex flex-col">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 2xl:grid-cols-4 gap-4">
        {Array.from({ length: 6 }).map((_, index) => (
          <ChartCardPlaceholder key={index} />
        ))}
      </div>
    </div>
  );
};

const EmbeddedHomeSkeleton = () => {
  const [viewMode] = useViewMode();
  return (
    <>
      <NewHomeLayoutTopNav>
        <div className="flex items-center">
          <span className="text-base text-grayscale-900 font-semibold">
            Embedded Charts
          </span>
        </div>
      </NewHomeLayoutTopNav>
      <NewHomeLayoutContent>
        <div className="font-sans h-full flex flex-col">
          <div className="flex flex-col p-6 gap-6 flex-1 min-h-0">
            <ChartToolsBar />
            {/* CARDS VIEW RENDERER  */}
            {viewMode === 'table' ? (
              <ChartCardViewTableSkeleton />
            ) : (
              <ChartCardViewGridSkeleton />
            )}
          </div>
        </div>
      </NewHomeLayoutContent>
    </>
  );
};

export { EmbeddedScreenSkeleton, EmbeddedHomeSkeleton };
